export default __webpack_public_path__ + "static/media/CustomerPortalIframe.f5e297aa.gif";